// Canonical client (tenant) slug registry. Slugs match the `apps/client-{slug}`
// directories, the `VITE_CLIENT_ID` values, the CDK `ClientStack` slugs, and the
// per-client deploy targets. Kept dependency-free so it is safe to import from
// any package.
//
// NOTE: `scripts/` and `cdk/` currently live in a separate module-resolution
// domain (they cannot resolve the `@common` alias) and still hardcode these
// slugs. Wire them up to this registry once their path resolution is enabled.

export const CLIENT_SLUGS = {
  CHAMP: 'champ',
  SYNRGY: 'synrgy',
  QUANTUM: 'quantum',
  HEALTHCUES: 'healthcues',
  ONHEALTH: 'onhealth',
} as const;

export type ClientSlug = (typeof CLIENT_SLUGS)[keyof typeof CLIENT_SLUGS];

export const ALL_CLIENT_SLUGS = Object.values(CLIENT_SLUGS) as ClientSlug[];
